import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher"
import { Company, ICompanyRepository } from "../domain/Company"
import { query_dispatcher_get } from "@/api/client";
import axios from "axios";
import { AnexoIData } from "./pdf_otorgamiento_repr_generator/OtorgamientoRep";


export class ApiCompanyRepository implements ICompanyRepository {
    query_dispatcher: QueryDispatcher
    constructor() {
        this.query_dispatcher = query_dispatcher_get
    }

    api_to_domain(data) {
        return new Company(data.id, data.code, data.type)
    }

    async find_by_type_and_code(user_id: number, code: string, cdb_type: string): Promise<Company | undefined> {
        const params = { user_id, code, companydb_type:cdb_type }
        let inv_data = await this.query_dispatcher.dispatch('company_by_type_code', params)
        if (inv_data){
            return this.api_to_domain(inv_data)
        }
        return null
    }

    async get_customer_data(company_id: number) {
        const params = { company_id }
        let res = await this.query_dispatcher.dispatch('get.customer.data', params)
        return res
    }

    async getPdfRepresentation(company_id: number, uuid: string): Promise<AnexoIData | null> {
        try {
            let queryURL = `/representation_pdf/?company_id=${company_id}&uuid=${uuid}`;
            const apiEndpoint = process.env.VUE_APP_API_ENDPOINT || '';
            let response = await axios.get(apiEndpoint + queryURL)
            if (response && response.data) {
                return response.data as AnexoIData
            }
            return null
        } catch (error) {
            console.error('Error en getPdfRepresentation:', error)
            return null
        }
    }
}